module.exports = {
  ScenariosData: () => {
    // Los "id" deben coincidir con los escenarios configurados en PlayCanvas (scenarioSelection):
    // "studio" (estudio según el color de la carrocería), "ciudad" y "fordgtbc".
    return [
      {
        "id": "studio",
        "name" : "Estudio",
        "icon": require('../assets/scenarios/icon-studio.png'),
        "iconselected": require('../assets/scenarios/icon-studio-white.png'),
        "interactable" : true,
        "active" : true,
      },
      {
        "id": "ciudad",
        "name" : "Ciudad",
        "icon": require('../assets/scenarios/icon-city.png'),
        "iconselected": require('../assets/scenarios/icon-city-white.png'),
        "interactable" : true,
        "active" : true,
      },
      // {
      //   "id": "fordgtbc",
      //   "name" : "Edificio",
      //   "icon": require('../assets/scenarios/icon-scenic.png'),
      //   "iconselected": require('../assets/scenarios/icon-scenic-white.png'),
      //   "interactable" : true,
      //   "active" : true,
      // },
    ]
  }
}
